import { createSlice } from "@reduxjs/toolkit";

import { NewProfileSlice } from "./types";

export const initialState: NewProfileSlice = {
  newUserProfile: undefined,
  newUserRole: undefined,
  newUserAvatar: undefined,
};

export const newProfileSlice = createSlice({
  name: "newProfileSlice",
  initialState,
  reducers: {
    setNewProfile: (state, action) => ({
      ...state,
      newUserProfile: action.payload,
    }),
    setNewProfileRole: (state, action) => ({
      ...state,
      newUserRole: action.payload,
    }),
    setNewProfileAvatar: (state, action) => ({
      ...state,
      newUserAvatar: action.payload,
    }),
  },
});

export const { setNewProfile, setNewProfileRole, setNewProfileAvatar } =
  newProfileSlice.actions;
export const newProfileReducer = newProfileSlice.reducer;
